<template>
  <GamingButtonValueIcon
    :to="to"
    :value="gaming.streak"
    :description="description"
  >
    <template #icon>
      <img
        src="/images/icons/gaming-streak.png"
        srcset="/images/icons/gaming-streak@2x.png 2x"
      />
    </template>
  </GamingButtonValueIcon>
</template>
<script setup lang="ts">
interface Props {
  to: string;
}
defineProps({
  to: null
});
const gaming = useGamingStore();
const description = computed(() => {
  return `jour${gaming.streak >= 2 ? 's' : ''} de suite`;
});
</script>
